"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2505],{

/***/ 76997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


var SvgComponent = function SvgComponent(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: onClick ? "button" : "img",
    onClick: onClick,
    style: {
      cursor: onClick ? "pointer" : "inherit"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      d: "M21.3103 6.87842L17.1216 2.68873C16.9823 2.5494 16.8169 2.43888 16.6349 2.36348C16.4529 2.28808 16.2578 2.24927 16.0608 2.24927C15.8638 2.24927 15.6687 2.28808 15.4867 2.36348C15.3047 2.43888 15.1393 2.5494 15 2.68873L3.43969 14.25C3.2998 14.3888 3.18889 14.554 3.11341 14.736C3.03792 14.918 2.99938 15.1132 3.00001 15.3103V19.5C3.00001 19.8978 3.15804 20.2793 3.43935 20.5606C3.72065 20.8419 4.10218 21 4.50001 21H8.6897C8.88675 21.0006 9.08197 20.9621 9.26399 20.8866C9.44602 20.8111 9.61122 20.7002 9.75001 20.5603L21.3103 8.99998C21.4496 8.86069 21.5602 8.69531 21.6356 8.5133C21.711 8.33129 21.7498 8.13621 21.7498 7.9392C21.7498 7.74219 21.711 7.5471 21.6356 7.36509C21.5602 7.18308 21.4496 7.01771 21.3103 6.87842ZM8.6897 19.5H4.50001V15.3103L12.75 7.06029L16.9397 11.25L8.6897 19.5ZM18 10.1887L13.8103 5.99998L16.0603 3.74998L20.25 7.93873L18 10.1887Z",
      fill: "black"
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);

/***/ }),

/***/ 65036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50253);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91315);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1438);
/* harmony import */ var components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92208);
/* harmony import */ var components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33574);
/* harmony import */ var components_Reusable_Bit_NextLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16110);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);
















var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
  displayName: "SuccessPaymentSecondary__StyledWrapper",
  componentId: "sc-1kxjbkk-0"
})(["display:grid;width:100%;align-items:flex-start;justify-items:center;grid-template-columns:1fr;gap:40px;padding:0 16px;margin-top:100px;margin-bottom:90px;", "{grid-template-columns:1fr 1fr;justify-items:end;gap:60px;margin-top:203px;margin-bottom:144px;padding-right:60px;padding-left:120px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledDiv = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)("div").withConfig({
  displayName: "SuccessPaymentSecondary__StyledDiv",
  componentId: "sc-1kxjbkk-1"
})(["display:flex;flex-direction:column;align-items:center;width:100%;min-height:100%;", "{align-items:flex-start;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledMainTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z).attrs({
  variant: "h1"
}).withConfig({
  displayName: "SuccessPaymentSecondary__StyledMainTitle",
  componentId: "sc-1kxjbkk-2"
})(["margin:0;margin-bottom:10px;font-size:50px;font-weight:900;line-height:40px;color:#000000;text-align:center;", "{text-align:right;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)("p").withConfig({
  displayName: "SuccessPaymentSecondary__StyledText",
  componentId: "sc-1kxjbkk-3"
})(["margin:0;font-size:24px;font-weight:400;line-height:30px;color:#000000;text-align:center;", "{text-align:right;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SuccessPaymentSecondary__StyledButtonWrapper",
  componentId: "sc-1kxjbkk-4"
})(["margin-top:", "px;margin-top:40px;"], function (p) {
  return (p === null || p === void 0 ? void 0 : p.$marginTop) || 0;
});

var SuccessPaymentSecondary = function SuccessPaymentSecondary(_ref) {
  var mainTitle = _ref.mainTitle,
      secondaryTitle = _ref.secondaryTitle;
  var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
  var isGroupPurchase = router.pathname.includes("groupPurchases");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)({
    imageUrl: "",
    alt: ""
  }),
      coverImg = _useState[0],
      setCoverImg = _useState[1];

  var _usePurchaseContext = (0,components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_4__/* .usePurchaseContext */ .AX)(),
      groupPurchaseData = _usePurchaseContext.groupPurchaseData;

  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _response$data, _response$data$body, response;

        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0,api__WEBPACK_IMPORTED_MODULE_1__.getGroupPurchaseGetGroupPurchaseSettings)();

              case 3:
                response = _context.sent;
                setCoverImg(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : _response$data$body.image);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    if (document) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(function () {
    (0,api__WEBPACK_IMPORTED_MODULE_1__.clearApiToken)();
  }, []);

  var redirectToHomepage = function redirectToHomepage(e) {
    e.preventDefault();
    router.push("/").then(function () {
      window.location.reload();
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledWrapper, {
    children: [(coverImg === null || coverImg === void 0 ? void 0 : coverImg.imageUrl) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
      src: coverImg.imageUrl,
      alt: coverImg.alt,
      layout: "fixed",
      width: isDesktop ? "422px" : "243px",
      height: isDesktop ? "245px" : "142px",
      style: {
        borderRadius: "22px",
        objectFit: "cover"
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledDiv, {
      children: [!mainTitle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledMainTitle, {
          children: ["\u05D0\u05D9\u05D6\u05D4 \u05DB\u05D9\u05E3 \u05D4\u05D5\u05E1\u05E4\u05E0\u05D5 \u05D0\u05EA \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD \u05E9\u05DC\u05DA \u05DC\u05E7\u05D1\u05D5\u05E6\u05EA ", isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("br", {}), //@ts-ignore
          "\"".concat(groupPurchaseData === null || groupPurchaseData === void 0 ? void 0 : groupPurchaseData.groupName, "\"")]
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledMainTitle, {
        children: mainTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledText, {
        children: secondaryTitle || "לאחר ביצוע ההזמנה אנחנו כמובן נשלח לך הודעה"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_Reusable_Bit_NextLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        href: "/",
        style: {
          marginTop: "auto"
        },
        onClick: redirectToHomepage,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledButtonWrapper, {
          $marginTop: isGroupPurchase ? "40px" : "30px",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            width: 220,
            btnType: "filled",
            children: isGroupPurchase ? "לחזרה לעמוד הבית" : "לדף הבית"
          })
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SuccessPaymentSecondary);

/***/ }),

/***/ 22505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PaymentSteps": function() { return /* binding */ PaymentSteps; },
  "default": function() { return /* binding */ payment; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./common/MediaQueries.tsx
var MediaQueries = __webpack_require__(1438);
// EXTERNAL MODULE: ./common/utils/formatters.ts
var formatters = __webpack_require__(93058);
// EXTERNAL MODULE: ./components/GenericInput/GenericInput.tsx
var GenericInput = __webpack_require__(9108);
// EXTERNAL MODULE: ./components/Icons/PencilIcon.tsx
var PencilIcon = __webpack_require__(76997);
// EXTERNAL MODULE: ./components/PurchasePage/GroupPurchasesContext.tsx
var GroupPurchasesContext = __webpack_require__(28218);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/PaymentContext.tsx
var PaymentContext = __webpack_require__(79625);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/bitHelpers.ts
var bitHelpers = __webpack_require__(11966);
// EXTERNAL MODULE: ./components/PurchasePage/PurchaseContext.tsx
var PurchaseContext = __webpack_require__(33574);
// EXTERNAL MODULE: ./components/Reusable/Bit/Form/FormikForm.tsx
var FormikForm = __webpack_require__(34968);
// EXTERNAL MODULE: ./components/Reusable/Bit/FormikSchema.ts
var FormikSchema = __webpack_require__(39163);
// EXTERNAL MODULE: ./components/Reusable/LoaderPopup.tsx
var LoaderPopup = __webpack_require__(34839);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(75741);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./components/GroupPurchases/GroupPurchasesAmountPage.tsx
var GroupPurchasesAmountPage = __webpack_require__(57706);
// EXTERNAL MODULE: ./components/GroupPurchases/GroupPurchasesHeader.tsx
var GroupPurchasesHeader = __webpack_require__(86057);
// EXTERNAL MODULE: ./components/GroupPurchases/GroupPurchasesPageCover.tsx
var GroupPurchasesPageCover = __webpack_require__(85991);
// EXTERNAL MODULE: ./components/GroupPurchases/LeaderDetailsPage.tsx
var LeaderDetailsPage = __webpack_require__(54819);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/GroupPurchases/PaymentIframeGroupPurchasesPage.tsx








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



























var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__StyledWrapper",
  componentId: "sc-1h57ysu-0"
})(["margin-top:50px;padding-right:0px;padding-left:0px;", "{padding-top:30px;}", "{display:flex;gap:15%;flex-direction:row-reverse;margin-top:120px;justify-content:space-between;margin-bottom:100px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledPaymentChoiceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__StyledPaymentChoiceContainer",
  componentId: "sc-1h57ysu-1"
})(["margin-bottom:-30px;", "{margin-bottom:90px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledPayments = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__StyledPayments",
  componentId: "sc-1h57ysu-2"
})(["display:flex;gap:25px;flex-direction:column;", ""], function (p) {
  return !p.$isDesktop && "justify-content: space-between;";
});
var StyledPayWithIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__StyledPayWithIcon",
  componentId: "sc-1h57ysu-3"
})(["line-height:20px;direction:ltr;display:flex;align-items:center;font-size:20px;font-family:Speedee,NarkisBlock,sans-serif;color:#000000;"]);
var StyledButtonText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__StyledButtonText",
  componentId: "sc-1h57ysu-4"
})(["text-align:right;font-family:", ";font-size:", ";font-weight:", ";font-stretch:condensed;font-style:normal;color:", ";"], function (p) {
  return p.$bit ? "poalimBIT-Medium" : "NarkisBlock";
}, function (p) {
  return p.$bit ? "20px" : "24px";
}, function (p) {
  return p.$bit ? "500" : "bold";
}, function (p) {
  return p.$bit ? p.theme.colors.white : p.theme.colors.black;
});
var StyledDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__StyledDivider",
  componentId: "sc-1h57ysu-5"
})(["border-right:1px solid ", ";width:1px;height:25px;margin-left:10px;margin-right:10px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.darkGreen;
});
var StyledImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__StyledImg",
  componentId: "sc-1h57ysu-6"
})(["margin-right:", ";margin-left:", ";"], function (p) {
  return p.$bit ? "15px" : "5px";
}, function (p) {
  return p.$marginLeft ? p.$marginLeft : "5px";
});
var StyledPaymentTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h2"
}).withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__StyledPaymentTitle",
  componentId: "sc-1h57ysu-7"
})(["text-align:right;font-family:Speedee,NarkisBlock;font-size:40px;font-weight:bold;font-stretch:condensed;font-style:normal;line-height:46px;letter-spacing:normal;"]);
var StyledPaymentButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
  variant: "outlined"
}).withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__StyledPaymentButton",
  componentId: "sc-1h57ysu-8"
})(["width:328px;height:56px;", "{width:100%;}border:", ";background:", ";color:", ";border-radius:8px;font-size:24px;font-weight:500;text-transform:none;&:hover{border-radius:10.125px;border:2.25px solid var(--Yellow,#ffbc0d);background:var(--White,#fff);box-shadow:0px 4.5px 9px 0px rgba(45,45,45,0.16);font-size:26px;}&:focus{border-radius:9px;border:2px solid var(--Yellow,#ffbc0d);background:var(--White,#fff);box-shadow:0px 4px 8px 0px rgba(45,45,45,0.16);}&:active{border-radius:8px;border:2px solid var(--Yellow,#ffbc0d);background:rgba(247,247,247,0.5);}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.$isBit ? "none" : "2px solid var(--Yellow, #FFBC0D);";
}, function (p) {
  return p.$isBit ? "linear-gradient(180deg, #2B5586 0%, #3B96B1 100%)" : p.theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme,
      $isBit = _ref2.$isBit;
  return $isBit ? theme.colors.white : theme.colors.black;
});
var NoPaymentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__NoPaymentWrapper",
  componentId: "sc-1h57ysu-9"
})(["text-align:right;"]);
var NoPaymentSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__NoPaymentSubtitle",
  componentId: "sc-1h57ysu-10"
})(["font-size:24px;line-height:30px;font-weight:400;text-align:right;"]);
var StyledTryAgainButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
  variant: "contained"
}).withConfig({
  displayName: "PaymentIframeGroupPurchasesPage__StyledTryAgainButton",
  componentId: "sc-1h57ysu-11"
})(["width:158px;height:48px;background-color:", ";border:none;color:", ";font-size:24px;border-radius:0px;line-height:30px;word-break:break-word;margin-top:25px;", "{width:100%;font-size:24px;}"], colors/* default.darkYellow */.Z.darkYellow, colors/* default.black */.Z.black, function (p) {
  return p.theme.breakpoints.down("sm");
});

var PaymentIframeGroupPurchasesPage = function PaymentIframeGroupPurchasesPage() {
  var amountInputRef = (0,react.useRef)(null);
  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();

  var _useState = (0,react.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react.useState)(null),
      availablePayment = _useState2[0],
      setAvailablePayment = _useState2[1];

  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      groupPurchaseData = _usePurchaseContext.groupPurchaseData,
      orderId = _usePurchaseContext.orderId,
      groupPurchaseUserGuid = _usePurchaseContext.groupPurchaseUserGuid,
      setPaymentInitiationId = _usePurchaseContext.setPaymentInitiationId,
      setTransactionSerialId = _usePurchaseContext.setTransactionSerialId,
      setGroupPurchaseData = _usePurchaseContext.setGroupPurchaseData;

  var _usePaymentContext = (0,PaymentContext/* usePaymentContext */.JL)(),
      setPaymentSteps = _usePaymentContext.setPaymentSteps;

  var _useGroupPurchasesCon = (0,GroupPurchasesContext/* useGroupPurchasesContext */.ZA)(),
      groupPurchasesData = _useGroupPurchasesCon.groupPurchasesData,
      setGroupPurchasesSteps = _useGroupPurchasesCon.setGroupPurchasesSteps,
      isAdmin = _useGroupPurchasesCon.isAdmin;

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    var _router$query;

    if ((router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.page) !== "groupPurchases") {
      if (!groupPurchaseData) router.push("/");
    }
  }, []);

  var _useState3 = (0,react.useState)(groupPurchaseData === null || groupPurchaseData === void 0 ? void 0 : groupPurchaseData.price),
      price = _useState3[0],
      setPrice = _useState3[1];

  (0,react.useEffect)(function () {
    groupPurchasesData && setGroupPurchaseData(groupPurchasesData);
  }, [groupPurchasesData]);
  (0,react.useEffect)(function () {
    setGroupPurchaseData(_objectSpread(_objectSpread({}, groupPurchaseData), {}, {
      price: price
    }));
  }, [price]);
  (0,react.useEffect)(function () {
    var getPaymentTypes = /*#__PURE__*/function () {
      var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _yield$getPaymentPaym, data;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,api.getPaymentPaymentMethods)(null, lib/* isChrome */.i7 ? "chrome" : lib/* isSafari */.G6 ? "safari" : lib/* isFirefox */.vU ? "firefox" : lib/* isOpera */.f0 ? "opera" : lib/* isEdge */.un ? "edge" : "other browser", groupPurchaseUserGuid);

              case 2:
                _yield$getPaymentPaym = _context.sent;
                data = _yield$getPaymentPaym.data;
                setAvailablePayment(data.body);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getPaymentTypes() {
        return _ref3.apply(this, arguments);
      };
    }();

    getPaymentTypes();
  }, []);
  var allValuesFalse = (0,react.useMemo)(function () {
    return availablePayment && Object.values(availablePayment).every(function (value) {
      return value === false;
    });
  }, [availablePayment]);
  /**
   * This function will be called when a user selects a payment option
   *
   *
   */

  (0,react.useEffect)(function () {
    var storedData = localStorage.getItem(groupPurchaseUserGuid);

    if (storedData) {
      var _JSON$parse = JSON.parse(storedData),
          expirationTime = _JSON$parse.expirationTime;

      var currentTime = new Date().getTime();

      if (currentTime > expirationTime) {
        localStorage.removeItem(groupPurchaseUserGuid);
      }
    }
  }, []);

  var handlePaymentSelection = function handlePaymentSelection(paymentOption) {
    if (!paymentOption) return;

    if (paymentOption === "creditCard") {
      router.push("/groupPurchases/payment/creditCard");
    }

    if (paymentOption === "apple/google") {
      router.push("/groupPurchases/payment/wallet");
    }
  };
  /**
   * Handling bit payment
   *
   *
   */


  var payBit = function payBit(transactionSerialId, paymentInitiationId) {
    (0,bitHelpers/* bitPay */.iw)({
      transactionSerialId: transactionSerialId,
      paymentInitiationId: paymentInitiationId,
      onApproval: function () {
        var _onApproval = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  setLoading(true);
                  _context2.next = 4;
                  return (0,api.postPaymentPaymentDoneBit)({
                    paymentInitiationId: paymentInitiationId
                  });

                case 4:
                  setLoading(false);
                  setPaymentSteps(PaymentSteps.SUCCESS);
                  _context2.next = 13;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2["catch"](0);
                  setLoading(false);
                  setPaymentSteps(PaymentSteps.FAILURE);
                  console.log(_context2.t0);

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 8]]);
        }));

        function onApproval() {
          return _onApproval.apply(this, arguments);
        }

        return onApproval;
      }(),
      onCancel: function () {
        var _onCancel = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
          return regenerator_default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  setLoading(true);
                  _context3.next = 4;
                  return (0,api.postPaymentPaymentDoneBit)({
                    paymentInitiationId: paymentInitiationId
                  });

                case 4:
                  setLoading(false);
                  _context3.next = 11;
                  break;

                case 7:
                  _context3.prev = 7;
                  _context3.t0 = _context3["catch"](0);
                  setLoading(false);
                  console.log(_context3.t0);

                case 11:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 7]]);
        }));

        function onCancel() {
          return _onCancel.apply(this, arguments);
        }

        return onCancel;
      }()
    });
  };

  var getBitPayment = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      var _yield$postPaymentGet, data;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              setLoading(true);
              _context4.next = 4;
              return (0,api.postPaymentGetGroupPurchaseBit)({
                groupPurchaseUserGuid: groupPurchaseUserGuid,
                amount: groupPurchaseData.price,
                browser: lib/* isChrome */.i7 ? "chrome" : lib/* isSafari */.G6 ? "safari" : lib/* isFirefox */.vU ? "firefox" : lib/* isOpera */.f0 ? "opera" : lib/* isEdge */.un ? "edge" : "other browser"
              });

            case 4:
              _yield$postPaymentGet = _context4.sent;
              data = _yield$postPaymentGet.data;
              setLoading(false);

              if (!isDesktop) {
                (0,bitHelpers/* saveGroupPurchasePaymentDataToLocalStorage */.Hz)(groupPurchaseUserGuid, {
                  paymentData: data.body.bitResponse,
                  groupPurchaseData: groupPurchaseData,
                  orderId: orderId,
                  groupPurchaseUserGuid: groupPurchaseUserGuid,
                  giftCardPrice: groupPurchaseData.price
                });
              }

              setTransactionSerialId(data.body.bitResponse.transactionSerialId);
              setPaymentInitiationId(data.body.bitResponse.paymentInitiationId);
              (0,bitHelpers/* loadBitCom */.ZI)({
                isDesktop: isDesktop,
                groupPurchaseUserGuid: groupPurchaseUserGuid,
                paymentInitiationId: data.body.bitResponse.paymentInitiationId,
                transactionSerialId: data.body.bitResponse.transactionSerialId,
                isAndroid: lib/* isAndroid */.Dt,
                isIOS: lib/* isIOS */.gn,
                pay: payBit
              });
              _context4.next = 17;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](0);
              setLoading(false);
              console.log(_context4.t0);

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 13]]);
    }));

    return function getBitPayment() {
      return _ref4.apply(this, arguments);
    };
  }();

  var groupPurchasesInitialData = {
    price: price || ""
  };
  var priceRef = (0,react.useRef)(null);

  var _useState4 = (0,react.useState)(0),
      maxAmount = _useState4[0],
      setMaxAmount = _useState4[1];

  (0,react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
        var response, maxAmountPriceResponse, _maxAmountPriceRespon, _response$data, _response$data$body;

        return regenerator_default().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return (0,api.getGroupPurchaseGetGroupPurchaseSettings)();

              case 3:
                response = _context5.sent;
                _context5.next = 6;
                return (0,api.postGroupPurchaseGroupPurchaseMaxPrice)({
                  //@ts-ignore
                  groupPurchaseGuid: groupPurchaseData.guid
                });

              case 6:
                maxAmountPriceResponse = _context5.sent;

                if (!isAdmin) {
                  setMaxAmount(maxAmountPriceResponse === null || maxAmountPriceResponse === void 0 ? void 0 : (_maxAmountPriceRespon = maxAmountPriceResponse.data) === null || _maxAmountPriceRespon === void 0 ? void 0 : _maxAmountPriceRespon.body);
                } else {
                  setMaxAmount(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : _response$data$body.maxPrice);
                }

                if (response && groupPurchasesData.price) {
                  if (priceRef.current) {
                    setTimeout(function () {
                      var _priceRef$current;

                      (_priceRef$current = priceRef.current) === null || _priceRef$current === void 0 ? void 0 : _priceRef$current.getElementsByTagName("input")[0].focus();
                      setTimeout(function () {
                        var _priceRef$current2;

                        (_priceRef$current2 = priceRef.current) === null || _priceRef$current2 === void 0 ? void 0 : _priceRef$current2.getElementsByTagName("input")[0].blur();
                      }, 50);
                    }, 50);
                  }
                }

                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);
                console.error(_context5.t0);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 11]]);
      }));

      return function fetchData() {
        return _ref5.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);
  var schemaGroupPurchasesAmount = es/* object */.Ry({
    price: es/* string */.Z_().matches(FormikSchema/* regex.amount */.Sz.amount, FormikSchema/* invalid.amount */.I1.amount).test("min-value", FormikSchema/* required.default */.C1["default"], function (value) {
      var numericValue = parseFloat(value === null || value === void 0 ? void 0 : value.replace(/[^\d.-]/g, ""));
      return numericValue > 0;
    }).test("max-value", FormikSchema/* invalid.groupPurchaseAmount */.I1.groupPurchaseAmount, function (value) {
      var numericValue = parseFloat(value === null || value === void 0 ? void 0 : value.replace(/[^\d.-]/g, ""));
      return numericValue <= maxAmount;
    }).required(FormikSchema/* required.default */.C1["default"])
  }).defined();

  var goBack = function goBack() {
    setGroupPurchasesSteps(GroupPurchasesContext/* GroupPurchasesSteps.LeaderDetails */.NT.LeaderDetails);
    router.push("/groupPurchases/otp");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GroupPurchasesPageCover/* default */.Z, {
      backBtnOnClick: goBack
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LeaderDetailsPage/* StyledMain */.P, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GroupPurchasesHeader/* default */.Z, {
        mainTitle: isAdmin ? "עכשיו זה הזמן להשלים את החלק שלך במתנה" : //@ts-ignore
        "\u05D4\u05D9\u05D9 \u05D4\u05D5\u05D6\u05DE\u05E0\u05EA \u05DC\u05D0\u05D9\u05E1\u05D5\u05E3 \u05DB\u05E1\u05E3 \u05E2\u05D1\u05D5\u05E8 \u05E8\u05DB\u05D9\u05E9\u05D4 \u05E7\u05D1\u05D5\u05E6\u05EA\u05D9\u05EA \u05DC \"".concat(groupPurchaseData === null || groupPurchaseData === void 0 ? void 0 : groupPurchaseData.groupName, "\" "),
        subTitle: isAdmin ? "\u05EA\u05E9\u05DC\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05E0\u05D9 \u05E0\u05D3\u05E8\u05E9 \u05DE\u05DE\u05DA \u05DB\u05D3\u05D9 \u05DC\u05D9\u05D9\u05E6\u05E8 \u05E7\u05D1\u05D5\u05E6\u05D4 \u05E2\u05DD \u05E1\u05DB\u05D5\u05DD \u05D4\u05EA\u05D7\u05DC\u05EA\u05D9. \u05D0\u05D7\"\u05DB \u05E0\u05E9\u05DC\u05D7 \u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05E9\u05D9\u05EA\u05D5\u05E3 \u05E2\u05DD \u05E9\u05D0\u05E8 \u05D4\u05DE\u05E9\u05EA\u05EA\u05E4\u05D9\u05DD." : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: ["\u05D4\u05EA\u05E9\u05DC\u05D5\u05DD \u05D9\u05EA\u05D1\u05E6\u05E2 \u05E8\u05E7 \u05DC\u05D0\u05D7\u05E8 \u05D4\u05E9\u05DC\u05DE\u05EA \u05D4\u05D4\u05D6\u05DE\u05E0\u05D4 \u05E2\"\u05D9 \u05DE\u05E0\u05D4\u05DC/\u05EA \u05D4\u05E7\u05D1\u05D5\u05E6\u05D4. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u05DC\u05DE\u05E9\u05DC\u05DE\u05D9\u05DD \u05D1\u05DB\u05E8\u05D8\u05D9\u05E1 \u05D3\u05D9\u05D9\u05E8\u05E7\u05D8 \u05D4\u05D7\u05D9\u05D5\u05D1 \u05D9\u05D4\u05D9\u05D4 \u05DE\u05D9\u05D9\u05D3\u05D9."]
        }),
        component: "h2",
        subtitleComponent: "body2",
        backBtnOnClick: goBack
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
        validationSchema: schemaGroupPurchasesAmount,
        initialValues: groupPurchasesInitialData,
        onSubmit: /*#__PURE__*/function () {
          var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(values) {
            var _values$price$split, _values$price$split2;

            return regenerator_default().wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    setGroupPurchaseData(_objectSpread(_objectSpread({}, groupPurchaseData), {}, {
                      price: values.price && typeof values.price === "string" ? parseInt((_values$price$split = values.price.split("₪")) === null || _values$price$split === void 0 ? void 0 : _values$price$split[((_values$price$split2 = values.price.split("₪")) === null || _values$price$split2 === void 0 ? void 0 : _values$price$split2.length) - 1]) : values.price
                    }));

                  case 1:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          }));

          return function (_x) {
            return _ref6.apply(this, arguments);
          };
        }(),
        render: function render(formik) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GroupPurchasesAmountPage/* StyledFieldWrapper */.Yc, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
                innerRef: priceRef,
                name: "price",
                label: "\u05D4\u05D6\u05E0\u05EA \u05E1\u05DB\u05D5\u05DD",
                type: "text",
                maxLength: 30,
                $width: "328",
                $mobileWidth: "100%",
                topMargin: "0",
                placeholder: "\u05E1\u05DB\u05D5\u05DD \u05DC\u05D0\u05E1\u05D5\u05E3 \u05DE\u05DB\u05DC \u05DE\u05E9\u05EA\u05EA\u05E3/\u05EA",
                numeric: true,
                inputRef: amountInputRef,
                $hasIcon: true,
                InputProps: {
                  startAdornment: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: function onClick() {
                      if (amountInputRef) {
                        var _amountInputRef$curre;

                        (_amountInputRef$curre = amountInputRef.current) === null || _amountInputRef$curre === void 0 ? void 0 : _amountInputRef$curre.focus();
                      }
                    },
                    "aria-label": "\u05E2\u05E8\u05D9\u05DB\u05EA \u05D4\u05E1\u05DB\u05D5\u05DD",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(PencilIcon/* default */.Z, {})
                  })
                },
                value: (0,formatters/* formatCurrencyWithSybmol */.Tp)(price || 0),
                onChange: function onChange(e) {
                  var _e$target$value$split, _e$target$value$split2;

                  setPrice(typeof e.target.value === "string" ? parseInt((_e$target$value$split = e.target.value.split("₪")) === null || _e$target$value$split === void 0 ? void 0 : _e$target$value$split[((_e$target$value$split2 = e.target.value.split("₪")) === null || _e$target$value$split2 === void 0 ? void 0 : _e$target$value$split2.length) - 1]) : e.target.value);
                }
              })
            }), !isAdmin && /*#__PURE__*/(0,jsx_runtime.jsxs)(GroupPurchasesAmountPage/* StyledInputLabelBottom */.O6, {
              children: ["\u05E0\u05D9\u05EA\u05DF \u05DC\u05E8\u05DB\u05D5\u05E9 \u05E2\u05D3 \u05DC\u05E1\u05DB\u05D5\u05DD \u05E9\u05DC ", maxAmount, " \u05E9\u201D\u05D7"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentChoiceContainer, {
              children: !allValuesFalse ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPayments, {
                  $isDesktop: isDesktop,
                  children: [(availablePayment === null || availablePayment === void 0 ? void 0 : availablePayment.creditCard) && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentButton, {
                    type: "submit",
                    onClick: function onClick() {
                      return (formik.initialValues && formik.isValid || formik.isValid && Object.keys(formik.touched).length > 0) && handlePaymentSelection("creditCard");
                    },
                    "aria-label": "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DB\u05E8\u05D8\u05D9\u05E1 \u05D0\u05E9\u05E8\u05D0\u05D9",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPayWithIcon, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonText, {
                        children: "\u05DB\u05E8\u05D8\u05D9\u05E1 \u05D0\u05E9\u05E8\u05D0\u05D9"
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImg, {
                        src: "/img/icons/CreditCardLogo.svg",
                        alt: ""
                      })]
                    })
                  }), (availablePayment === null || availablePayment === void 0 ? void 0 : availablePayment.wallet) && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentButton, {
                    type: "submit",
                    onClick: function onClick() {
                      return (formik.initialValues && formik.isValid || formik.isValid && Object.keys(formik.touched).length > 0) && handlePaymentSelection("apple/google");
                    },
                    "aria-label": "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D0\u05E8\u05E0\u05E7 \u05D3\u05D9\u05D2\u05D9\u05D8\u05DC\u05D9 \u05D2\u05D5\u05D2\u05DC \u05E4\u05D9\u05D9 \u05D0\u05D5 \u05D0\u05E4\u05DC \u05E4\u05D9\u05D9",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPayWithIcon, {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledImg, {
                          src: "/img/icons/GooglePayIcon.svg",
                          alt: "",
                          $marginLeft: "0px"
                        }), "Pay"]
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDivider, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPayWithIcon, {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledImg, {
                          src: "/img/icons/ApplePayIcon.svg",
                          alt: ""
                        }), "Pay"]
                      })]
                    })
                  }), (availablePayment === null || availablePayment === void 0 ? void 0 : availablePayment.bit) && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentButton, {
                    $isBit: true,
                    type: "submit",
                    onClick: function onClick() {
                      return (formik.initialValues && formik.isValid || formik.isValid && Object.keys(formik.touched).length > 0) && getBitPayment();
                    },
                    "aria-label": "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D1\u05D9\u05D8",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPayWithIcon, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledImg, {
                        src: "/img/icons/bitLogo.svg",
                        alt: "",
                        $bit: true
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButtonText, {
                        $bit: true,
                        children: [" ", "\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA"]
                      })]
                    })
                  })]
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(NoPaymentWrapper, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPaymentTitle, {
                  children: "\u05D0\u05D5\u05E4\u05E1\u05D9, \u05D0\u05D9 \u05D0\u05E4\u05E9\u05E8 \u05DC\u05D1\u05E6\u05E2 \u05E8\u05DB\u05D9\u05E9\u05D4 \u05DB\u05E8\u05D2\u05E2 \u05D1\u05D0\u05EA\u05E8"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(NoPaymentSubtitle, {
                  children: "\u05D0\u05E0\u05D7\u05E0\u05D5 \u05E2\u05DC \u05D6\u05D4! \u05D1\u05D1\u05E7\u05E9\u05D4 \u05DC\u05E0\u05E1\u05D5\u05EA \u05E9\u05D5\u05D1 \u05D1\u05E7\u05E8\u05D5\u05D1"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTryAgainButton, {
                  onClick: function onClick() {
                    return router.push("/groupPurchases");
                  },
                  children: "\u05D1\u05D5\u05D0\u05D5 \u05E0\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1"
                })]
              })
            })]
          });
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LoaderPopup/* default */.Z, {
        isOpen: loading
      })]
    })]
  });
};

/* harmony default export */ var GroupPurchases_PaymentIframeGroupPurchasesPage = (PaymentIframeGroupPurchasesPage);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/BlockedPayment.tsx
var BlockedPayment = __webpack_require__(63087);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/FailedPage.tsx
var FailedPage = __webpack_require__(69045);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/SuccessPayment.tsx
var SuccessPayment = __webpack_require__(66258);
// EXTERNAL MODULE: ./components/PurchasePage/Preview/Payment/SuccessPaymentSecondary.tsx
var SuccessPaymentSecondary = __webpack_require__(65036);
// EXTERNAL MODULE: ./components/Reusable/Loader.tsx
var Loader = __webpack_require__(83457);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/groupPurchases/payment.tsx












var ENV = "production";
var PaymentSteps;

(function (PaymentSteps) {
  PaymentSteps[PaymentSteps["PAYMENT"] = 1] = "PAYMENT";
  PaymentSteps[PaymentSteps["FAIL"] = 2] = "FAIL";
  PaymentSteps[PaymentSteps["SUCCESS"] = 3] = "SUCCESS";
  PaymentSteps[PaymentSteps["FAILURE"] = 4] = "FAILURE";
  PaymentSteps[PaymentSteps["LOADER"] = 5] = "LOADER";
  PaymentSteps[PaymentSteps["BLOCKED"] = 6] = "BLOCKED";
})(PaymentSteps || (PaymentSteps = {}));

var Payment = function Payment() {
  var _usePaymentContext = (0,PaymentContext/* usePaymentContext */.JL)(),
      paymentSteps = _usePaymentContext.paymentSteps,
      setPaymentSteps = _usePaymentContext.setPaymentSteps,
      setIframeLink = _usePaymentContext.setIframeLink;

  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      groupPurchaseGuid = _usePurchaseContext.groupPurchaseGuid;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [ENV !== "production" ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          src: "https://ppsuat.creditguard.co.il/plugins/applePayOnIframe.js"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        src: "https://pps.creditguard.co.il/plugins/applePayOnIframe.js"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      })]
    }), paymentSteps === PaymentSteps.PAYMENT && /*#__PURE__*/(0,jsx_runtime.jsx)(GroupPurchases_PaymentIframeGroupPurchasesPage, {}), paymentSteps === PaymentSteps.FAIL && /*#__PURE__*/(0,jsx_runtime.jsx)(FailedPage/* default */.Z, {
      title: "\u05D0\u05D5\u05D9.. \u05D7\u05D9\u05D5\u05D1 \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD \u05E0\u05DB\u05E9\u05DC",
      text: "\u05E0\u05E8\u05D0\u05D4 \u05E9\u05D9\u05E9 \u05D1\u05E2\u05D9\u05D4 \u05D1\u05EA\u05E7\u05E9\u05D5\u05E8\u05EA \u05D0\u05D5 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D9 \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD",
      link: "/groupPurchases/payment",
      setPaymentSteps: setPaymentSteps,
      setIframeLink: setIframeLink
    }), paymentSteps === PaymentSteps.SUCCESS && (groupPurchaseGuid ? /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPaymentSecondary/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessPayment/* default */.Z, {})), paymentSteps === PaymentSteps.FAILURE && /*#__PURE__*/(0,jsx_runtime.jsx)(FailedPage/* default */.Z, {
      title: "\u05D0\u05D5\u05E4\u05E1\u05D9, \u05DE\u05E9\u05D4\u05D5 \u05D4\u05E9\u05EA\u05D1\u05E9 \u05D1\u05D3\u05E8\u05DA",
      text: "\u05D0\u05DD \u05D4\u05D1\u05E2\u05D9\u05D4 \u05DE\u05DE\u05E9\u05D9\u05DB\u05D4 \u05D0\u05E4\u05E9\u05E8 \u05DC\u05E4\u05E0\u05D5\u05EA \u05DC\u05E9\u05D9\u05E8\u05D5\u05EA \u05DC\u05E7\u05D5\u05D7\u05D5\u05EA.",
      link: "/groupPurchases/payment",
      setPaymentSteps: setPaymentSteps,
      setIframeLink: setIframeLink
    }), paymentSteps === PaymentSteps.LOADER && /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}), paymentSteps === PaymentSteps.BLOCKED && /*#__PURE__*/(0,jsx_runtime.jsx)(BlockedPayment/* default */.Z, {})]
  });
};

/* harmony default export */ var payment = (Payment);

/***/ })

}]);